{
  "maximum": "最大值",
  "minimum": "最小值"
}
